import { Component, Input } from "@angular/core";
import { EmbeddedIntegrationData, ThirdPartySectionComponent } from "../third-party-section.component";
import { Router } from "@angular/router";
import { SharedModule } from "@Shared/shared.module";
import { MrasAppModule } from "@Components/mras/mras-app.module";

@Component({
    selector: 'mras-interview-component',
    host: { 'class': 'content' },
    templateUrl: './mras-interview.component.html',
    imports: [SharedModule, MrasAppModule]
})
export class MrasInterviewComponent implements ThirdPartySectionComponent {

    private _embeddedData: EmbeddedIntegrationData;
    
    @Input() set embeddedData(value) {
        this._embeddedData = value;

        this.setParameters();
    }

    mrasData: any;

    caseId: any;
    interviewId: any;
    pageIndex: any;
    activeEnvironment: any;
    summaryMode = false;

    constructor(public router: Router) {}

    ngOnInit(){
        this.setParameters();
    }

    setParameters(){
        this.mrasData = JSON.parse(this._embeddedData.payloadData);

        this.caseId = this.mrasData.caseId;
        this.interviewId = this.mrasData.interviewId;
        this.pageIndex = this.mrasData.pageIndex;
        this.activeEnvironment = this.mrasData.activeEnvironment;
        this.summaryMode = this._embeddedData.isCaseSummary;
    }

}